<app-logo class="p-15"></app-logo>

<div class="vsidebar">
    <app-text-field [beLight]="true" (input)="onSearchInput($event)" [isEditable]="true"
                    class="dashboardSearch" [searchIcon]="true"
                    [placeholder]="'Search...'" fxLayout="column">
    </app-text-field>
    <mat-nav-list class="vmenu-list-item">
        <ng-container *ngIf="navList?.length">
            <app-menu-list-item *ngFor="let item of navList[0]?.modules | filter: searchText: 'name'; index as i"
                                [item]="item" id="dy{{i}}" [expanded]="navService?.expanded">
            </app-menu-list-item>
        </ng-container>

        <!-- //static Nav Items -->
        <app-menu-list-item *ngFor="let item of navItems | filter: searchText: 'displayName'; index as j" [item]="item"
                            id="st{{j}}"
                            [goto_url]="externalAppUrl" [expanded]="navService?.expanded">
        </app-menu-list-item>
    </mat-nav-list>
    <!-- <button mat-raised-button (click)="navigateArthakosh()">Invoices</button> -->
    <!-- <logzy-go-to-external-app *ngIf="showArthakoshLink" [goto_url]="externalAppUrl" [button_label]="'Invoices'"></logzy-go-to-external-app> -->
</div>
